/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Change, ChangeOptions, ObservableModel, ObserveModes } from '@typescript-kit/core';
import { User } from '@typescript-kit/authentication';
import { View } from '../model/view.model';

export interface ShellViewData {
  appTitle?: string;
  user?: User;
  viewList?: View[];
  view?: View;
  isLoading?: boolean;
  isPrinting?: boolean;
}

export class ShellViewFieldKey {
  static readonly APP_TITLE = 'appTitle';
  static readonly USER = 'user';
  static readonly VIEW_LIST = 'viewList';
  static readonly VIEW = 'view';
  static readonly IS_LOADING = 'isLoading';
  static readonly IS_PRINTING = 'isPrinting';
}

export class ShellViewModel extends ObservableModel implements ShellViewData {
  static readonly KEYS = Object.keys(ShellViewFieldKey).map((key) => ShellViewFieldKey[key]);

  constructor(data?: ShellViewData) {
    super(data, ShellViewModel.KEYS, { observeMode: ObserveModes.FLAT });
  }

  get appTitle(): string {
    return this.get(ShellViewFieldKey.APP_TITLE);
  }

  set appTitle(value: string) {
    this.set(ShellViewFieldKey.APP_TITLE, value);
  }

  get user(): User {
    return this.get(ShellViewFieldKey.USER);
  }

  set user(value: User) {
    this.set(ShellViewFieldKey.USER, value);
  }

  get viewList(): View[] {
    return this.get(ShellViewFieldKey.VIEW_LIST);
  }

  set viewList(value: View[]) {
    this.set(ShellViewFieldKey.VIEW_LIST, value);
  }

  get view(): View {
    return this.get(ShellViewFieldKey.VIEW);
  }

  set view(value: View) {
    this.set(ShellViewFieldKey.VIEW, value);
  }

  get isLoading(): boolean {
    return this.get(ShellViewFieldKey.IS_LOADING);
  }

  set isLoading(value: boolean) {
    this.set(ShellViewFieldKey.IS_LOADING, value);
  }

  get isPrinting(): boolean {
    return this.get(ShellViewFieldKey.IS_PRINTING);
  }

  set isPrinting(value: boolean) {
    this.set(ShellViewFieldKey.IS_PRINTING, value);
  }

  setValues(values: ShellViewData, options?: ChangeOptions): { [p: string]: Change<any> } {
    return super.setValues(values, options);
  }
}
